import profile from '@/mixins/profile'

export default {
  mixins: [profile],

  computed: {
    reqCountry () {
      return {
        /**
         * @return {Boolean}
         */
        USA: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 6252001,
        RUSSIA: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 2017370,
        KAZAKHSTAN: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 1522867,
        UKRAINE: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 690791,
        BELARUS: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 630336,
        MOLDOVA: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 617790,
        MEXICO: this.profile && this.profile.reqCountry && this.profile.reqCountry.id === 3996063
      }
    }
  }
}
